import classes from "./InputField.module.css";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { IoChevronDownOutline } from "react-icons/io5";
import { useState, useRef, useEffect } from "react";

const InputField = ({
  labelText,
  className,
  labelStyle,
  type = "text",
  placeholder,
  showEye,
  onChange,
  value,
  name,
  disabled,
  error,
  dropdownOptions = null,
  dropdownClass,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef(null);

  const handleDropdownSelect = (option, e) => {
    e.stopPropagation(); // Prevents triggering parent click which toggles dropdown
    setSelectedOption(option);
    onChange?.({ target: { name, value: option.value } });
    setShowDropdown(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={`${classes.wrapper} ${className}`} ref={dropdownRef}>
      {labelText && (
        <label
          style={labelStyle}
          className={disabled ? classes.disabledLabel : ""}
        >
          {labelText}
        </label>
      )}

      {dropdownOptions ? (
        <div
          className={`${classes.dropdownWrapper} ${
            disabled ? classes.disabled : ""
          }`}
          onClick={() => {
            if (!disabled) {
              setShowDropdown((prev) => !prev);
            }
          }}
        >
          <div
            className={`${classes.dropdownInput} ${
              placeholder && !value && classes.placeholderText
            } ${dropdownClass} d-flex justify-between align-items-center`}
          >
            <span>
              {dropdownOptions?.find((opt) => opt.value === value)?.label ||
                placeholder}
            </span>
            <IoChevronDownOutline
              className={`${classes.dropdownIcon} ${
                showDropdown ? classes.rotateUp : ""
              }`}
              size={18}
              color="#AFAFAF"
            />
          </div>

          {!disabled && showDropdown && (
            <div className={classes.dropdownCard}>
              {dropdownOptions.map((option) => (
                <div
                  key={option.value}
                  className={classes.dropdownItem}
                  onClick={(e) => handleDropdownSelect(option, e)}
                >
                  {option.label}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div
          className={`${classes.inputContainer} d-flex align-items-center gap-2`}
        >
          <input
            type={showPassword ? "text" : type}
            placeholder={placeholder}
            onChange={onChange}
            value={value}
            name={name}
            disabled={disabled}
          />
          {showEye &&
            (showPassword ? (
              <IoEyeOutline
                size={18}
                color="#AFAFAF"
                role="button"
                onClick={() => setShowPassword(false)}
              />
            ) : (
              <IoEyeOffOutline
                size={18}
                color="#AFAFAF"
                role="button"
                onClick={() => setShowPassword(true)}
              />
            ))}
        </div>
      )}

      <div className={`${classes.error}`}>{error}</div>
    </div>
  );
};

export default InputField;
